import { render, staticRenderFns } from "./InvitationCreateForm.vue?vue&type=template&id=b224f1c0&"
import script from "./InvitationCreateForm.vue?vue&type=script&lang=js&"
export * from "./InvitationCreateForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports